<template>
  <div class="mt-6">
    <h4 class="mb-2">КАТМ - Кредитная история</h4>
    <v-card>
      <validation-observer v-slot="{handleSubmit}" ref="katmFormObs">
        <form @submit.prevent="handleSubmit(toKatmInfo)">
          <v-card-text>
            <v-row dense>
              <v-col md="4" sm="6" cols="12">
                <custom-input-text
                    always-uppercase
                    label="Серия паспорта"
                    name="Серия паспорта"
                    v-mask="'AA'"
                    rules="required"
                    vid="passport_series"
                    v-model="katmFormData.passport_series"
                ></custom-input-text>
              </v-col>
              <v-col md="4" sm="6" cols="12">
                <custom-input-text
                    label="Номер паспорта"
                    name="Номер паспорта"
                    v-mask="'#######'"
                    counter="7"
                    rules="required"
                    vid="passport_number"
                    v-model="katmFormData.passport_number"
                ></custom-input-text>
              </v-col>
              <!--                <v-col md="4" sm="6" cols="12">-->
              <!--                  <custom-input-text-->
              <!--                    always-uppercase-->
              <!--                    label="Адрес по паспорту"-->
              <!--                    name="Адрес по паспорту"-->
              <!--                    vid="passport_address"-->
              <!--                    rules="required"-->
              <!--                    v-model="katmFormData.passport_address"-->
              <!--                  ></custom-input-text>-->
              <!--                </v-col>-->
              <!--                <v-col md="4" sm="6" cols="12">-->
              <!--                  <custom-input-text-->
              <!--                    always-uppercase-->
              <!--                    label="Место рождения"-->
              <!--                    name="Место рождения"-->
              <!--                    rules="required"-->
              <!--                    vid="birth_address"-->
              <!--                    v-model="katmFormData.birth_address"-->
              <!--                  ></custom-input-text>-->
              <!--                </v-col>-->
              <v-col md="4" sm="6" cols="12">
                <custom-autocomplete
                    vid="region_id"
                    v-model="katmFormData.region_katm_code"
                    :items="regions"
                    item-value="katm_code"
                    @input="getDistrict"
                    rules="required"
                    label="Регион"
                    name="Регион"
                ></custom-autocomplete>
              </v-col>
              <v-col md="4" sm="6" cols="12">
                <custom-select
                    item-value="katm_code"
                    vid="district_id"
                    v-model="katmFormData.district_katm_code"
                    :loading="districtLoading"
                    :items="districts"
                    rules="required"
                    label="Район"
                    name="Район"
                ></custom-select>
              </v-col>
              <v-col md="4" sm="6" cols="12">
                <custom-input-text
                    label="ПИНФЛ"
                    name="ПИНФЛ"
                    v-mask="'##############'"
                    counter="14"
                    rules="required|pnfl"
                    vid="pnfl"
                    v-model="katmFormData.pnfl"
                ></custom-input-text>
              </v-col>
              <v-col md="4" sm="6" cols="12">
                <custom-input-text
                    prefix="+998"
                    pattern="##-###-##-##"
                    label="Номер телефона"
                    name="Номер телефона"
                    rules="required|phone"
                    vid="phone"
                    v-model="katmFormData.user_phone"
                ></custom-input-text>
              </v-col>
              <!--                <v-col md="4" sm="6" cols="12">-->
              <!--                  <money-input-->
              <!--                    v-model="katmFormData.amount"-->
              <!--                    rules="required"-->
              <!--                    vid="amount"-->
              <!--                    label="Сумма"-->
              <!--                  ></money-input>-->
              <!--                </v-col>-->
            </v-row>

            <div class="d-flex flex-wrap ma-n2 justify-end flex-column flex-md-row">
              <div class="pa-2 flex-grow-1">
                <v-btn :width="$vuetify.breakpoint.mdAndDown ? '100%': null"
                       @click="isVisibleCreditHistory = !isVisibleCreditHistory" color="secondary">Посмотреть историю
                </v-btn>
              </div>
              <div class="pa-2">
                <v-btn :width="$vuetify.breakpoint.mdAndDown ? '100%': null" color="primary"
                       @click="handleSubmit(getBenefitInfo)"
                       :disabled="!mko.can_katm_info">Пенсия и пособия
                </v-btn>
              </div>
              <div class="pa-2">
                <v-btn :width="$vuetify.breakpoint.mdAndDown ? '100%': null" color="primary" type="submit"
                       :disabled="!mko.can_katm_info">Кредитная история
                </v-btn>
              </div>
              <div class="pa-2">
                <v-btn :width="$vuetify.breakpoint.mdAndDown ? '100%': null" color="primary darken-2"
                       @click="getKatmSalaryInfo" :disabled="!mko.can_katm_salary"
                       type="button">Сведение о доходах
                </v-btn>
              </div>
            </div>
          </v-card-text>
        </form>
      </validation-observer>
      <v-expansion-panels flat :value="isVisibleCreditHistory? 0 :null">
        <v-expansion-panel>
          <v-expansion-panel-content>
            <v-data-table
                :loading="creditHistoryTableLoading"
                hide-default-footer
                disable-pagination
                :items="creditHistory"
                :headers="creditHistoryTableHeaders">
              <template #item.created_at="{item}">{{ item.created_at |parseDate }}</template>
              <template #item.action="{item}">
                <v-btn
                    :disabled="(item.report_type === 1 && !mko.can_katm_info)||(item.report_type === 24 && !mko.can_katm_salary)"
                    @click="getCreditInfo(item)" class="action-btn" color="primary">
                  <v-icon>fas fa-eye</v-icon>
                </v-btn>
              </template>
            </v-data-table>

          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>

    <!--    info dialog opened when click benefit button-->
    <katm-benefit-info-dialog ref="KatmBenefitInfoDialog"/>
  </div>
</template>

<script>
import KatmBenefitInfoDialog from "@/components/calculation/katm/KatmBenefitInfoDialog";

export default {
  name: 'KatmCreditHistory',
  components: {KatmBenefitInfoDialog},
  data() {
    return {
      creditHistoryTableLoading: false,
      creditHistory: [],
      isVisibleCreditHistory: false,
      regions: [],
      districts: [],
      katmFormData: {},
      districtLoading: false,
      creditHistoryTableHeaders: [
        {
          text: 'Id',
          value: 'id'
        },
        {
          text: 'Дата создания',
          value: 'created_at'
        },
        {
          text: 'Паспорт',
          value: 'passport'
        },
        {
          text: 'ПИНФЛ',
          value: 'pinfl'
        },
        {
          text: 'Телефон',
          value: 'pPhone'
        },
        {
          text: 'Тип',
          value: 'type'
        },
        {
          text: 'Действие',
          value: 'action'
        },
      ]
    }
  },
  computed: {
    mko() {
      return this.$store.getters.mko
    }
  },
  watch: {
    isVisibleCreditHistory(val) {
      if (val) {
        this.getHistory()
      }
    }
  },
  methods: {
    async getBenefitInfo() {
      this.$showLoading()
      try {
        const {data: {data}} = await this.$http.post('admin/calculate/katm-pensioner-salary', this.katmFormData)
        const report = JSON.parse(data)
        this.$refs.KatmBenefitInfoDialog.open(report.report.sizepension)
        const {katmFormObs} = this.$refs
        this.katmFormData = {}
        if (katmFormObs) katmFormObs.reset()
      } catch (error) {
        this.$setResponseError({error})
      } finally {
        this.$clearLoading()
      }
    },
    async getCreditInfo(item) {
      const {report_type, credit_id, pinfl, passport, region_katm_code, pPhone} = item
      const data = {
        credit_id,
        pnfl: pinfl,
        passport_series: passport.substring(0, 2),
        passport_number: passport.substring(3),
        region_katm_code,
        district_katm_code: 111111,
        user_phone: pPhone
      }
      if (report_type === 1) {
        this.katmInfo(data)
      } else if (report_type === 24) {
        this.salaryInfo(data)
      }
    },
    async getHistory() {
      this.creditHistoryTableLoading = true
      try {
        const {data: {data}} = await this.$http.get('admin/calculate/katm-history')
        this.creditHistory = data
      } catch (e) {
        this.$setResponseError({error: e})
      } finally {
        this.creditHistoryTableLoading = false
      }
    },
    async getKatmSalaryInfo() {
      let success = await this.$refs.katmFormObs.validate();
      if (success) {
        let data = {...this.katmFormData}
        // const {katmFormObs} = this.$refs
        data.region_katm_code = parseInt(data.region_katm_code)
        this.salaryInfo(data)
        // this.katmFormData = {}
        // if (katmFormObs) katmFormObs.reset()
      }
    },
    salaryInfo(data, params = {}) {
      let routeData = this.$router.resolve({name: 'user-salary-info', query: data, params})
      window.open(routeData.href, '_blank');
    },
    async getDistrict(katm_code, firstLoad = false) {
      this.districtLoading = true
      let region = this.regions.find(item => item.katm_code === katm_code)
      try {
        this.districts = await this.$store.dispatch('getDistrict', region.id)
        if (!firstLoad) {
          this.katmFormData.district_id = null
        }
      } catch (e) {
        this.$setResponseError({error: e})
      } finally {
        this.districtLoading = false
      }

    },
    katmInfo(data, params = {}) {
      let routeData = this.$router.resolve({name: 'user-info', query: data, params})
      window.open(routeData.href, '_blank');
    },
    toKatmInfo() {
      let data = {...this.katmFormData}
      // const {katmFormObs} = this.$refs
      data.region_katm_code = parseInt(data.region_katm_code)
      this.katmInfo(data)
      // this.katmFormData = {}
      // if (katmFormObs) katmFormObs.reset()
    },
    async init() {
      this.$showLoading()
      try {
        this.regions = await this.$store.dispatch('getRegions')
      } catch (e) {
        this.$setResponseError({error: e})
      } finally {
        this.$clearLoading()
      }
    },
  },
  created() {
    this.init()
  },
}
</script>